import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImagePipe } from '../../pipes/image.pipe';
import { LiveViewPipe } from '../../pipes/live-view.pipe';
import { PrinterNamePipe } from '../../pipes/printerName.pipe';
import { PrinterStatusPipe } from '../../pipes/printerStatus.pipe';
import { StatePipe } from '../../pipes/state.pipe';
import { SharedModule } from '../shared.module';
import { PrinterViewerComponent } from './components/printer-viewer/printer-viewer.component';
import { EditVisitDialogComponent } from './dialogs/edit-visit/edit.component';
import { OpenBarDialogComponent } from './dialogs/openBar-dialog/openBar.dialog.component';
import { PrinterDialogComponent } from './dialogs/printer-dialog/printer.dialog.component';
import { ListComponent } from './pages/list/list.component';



@NgModule({
  declarations: [
    StatePipe,
    ImagePipe,
    LiveViewPipe
  ],
  imports: [],
  providers: [],
  exports:[
    StatePipe,
    ImagePipe,
    LiveViewPipe
    ]
})
export class ControlModule {}
